import React from 'react';
import { BadgeJapaneseYen, Clock, Zap, ArrowRight } from 'lucide-react';


const Hero: React.FC = () => {
  return (
    <div className="relative overflow-hidden bg-[#1B2A4A]">
      {/* 背景画像 */}
      <div className="absolute inset-0">
        <picture>
          <source srcSet="/images/hero-sp.webp" media="(max-width: 768px)" />
          <img
            src="/images/hero-pc.webp"
            alt=""
            className="w-full h-full object-cover"
          />
        </picture>
        <div className="absolute inset-0 bg-gradient-to-r from-[#1B2A4A]/90 via-[#1B2A4A]/75 to-[#1B2A4A]/50 lg:to-transparent" />
      </div>

      {/* コンテンツ */}
      <div className="relative mx-auto max-w-6xl px-5 lg:px-6">
        <div className="grid lg:grid-cols-2 gap-8 items-start min-h-[100svh] pb-10 lg:pb-14" style={{ paddingTop: 'clamp(140px, 20vw, 200px)' }}>
          {/* 左カラム: テキスト */}
          <div className="max-w-xl">
            {/* バッジ */}
            <div className="flex flex-wrap items-center gap-3 mb-6">
              <div className="inline-flex items-center gap-2 rounded-full border border-[#B8860B]/40 bg-[#B8860B]/10 px-4 py-1.5">
                <span className="text-base font-semibold text-[#B8860B]">中小企業のIT化を、もっと身近に</span>
              </div>
              <div className="inline-flex items-center gap-1.5 rounded-full border border-[#F5F3EF]/20 bg-white/10 px-3 py-1.5">
                <span className="text-xs font-bold text-[#F5F3EF]/90">設立26年</span>
                <span className="text-[#F5F3EF]/40">|</span>
                <span className="text-xs font-bold text-[#F5F3EF]/90">広島</span>
              </div>
            </div>

            {/* メインヘッドライン */}
            <h1 className="text-[2.1rem] sm:text-5xl lg:text-[3.5rem] font-bold text-[#F5F3EF] mb-5">
              <span className="block">見積もり費用を</span>
              <span className="block -mt-1 sm:mt-4"><span className="text-[#B8860B]">60%OFF</span>に。</span>
            </h1>

            {/* サブコピー */}
            <p className="text-base lg:text-lg text-[#F5F3EF]/80 leading-relaxed mb-8 max-w-md text-justify">
              AI × 代表直接開発で、従来の60〜80%OFFに。設立26年の信頼と最新技術で、中小企業のシステム開発を変えます。
            </p>

            {/* CTA */}
            <div className="flex flex-col gap-3 mb-10">
              <a
                href="#contact"
                className="group inline-flex items-center justify-center gap-2 rounded-lg bg-[#B8860B] px-7 py-3.5 text-white font-semibold hover:bg-[#A0750A] transition-colors shadow-lg shadow-[#B8860B]/30 text-base sm:self-start"
              >
                無料で相談する（30分・オンライン）
                <ArrowRight className="h-4 w-4 transform group-hover:translate-x-1 transition-transform" />
              </a>
              <span className="text-xs text-[#F5F3EF]/50 sm:self-start">※ 月の相談枠に限りがあります。お早めにどうぞ。</span>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-3">
              <div className="rounded-xl border border-[#F5F3EF]/15 bg-white/5 backdrop-blur-sm px-3 py-3 text-center">
                <div className="flex justify-center mb-1.5">
                  <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-[#B8860B]/20">
                    <BadgeJapaneseYen className="h-4 w-4 text-[#C8913A]" />
                  </div>
                </div>
                <div className="text-[#F5F3EF]">
                  <span className="text-2xl sm:text-3xl font-bold">60</span>
                  <span className="text-xs sm:text-sm font-medium opacity-70">%OFF〜</span>
                </div>
                <div className="text-[10px] sm:text-xs text-[#F5F3EF]/60 mt-1">従来の開発費用から</div>
              </div>
              <div className="rounded-xl border border-[#F5F3EF]/15 bg-white/5 backdrop-blur-sm px-3 py-3 text-center">
                <div className="flex justify-center mb-1.5">
                  <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-[#B8860B]/20">
                    <Clock className="h-4 w-4 text-[#C8913A]" />
                  </div>
                </div>
                <div className="text-[#F5F3EF]">
                  <span className="text-2xl sm:text-3xl font-bold">1</span>
                  <span className="text-sm sm:text-base font-medium opacity-70">〜</span>
                  <span className="text-2xl sm:text-3xl font-bold">3</span>
                  <span className="text-xs sm:text-sm font-medium opacity-70">ヶ月</span>
                </div>
                <div className="text-[10px] sm:text-xs text-[#F5F3EF]/60 mt-1">平均開発期間</div>
              </div>
              <div className="rounded-xl border border-[#F5F3EF]/15 bg-white/5 backdrop-blur-sm px-3 py-3 text-center">
                <div className="flex justify-center mb-1.5">
                  <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-[#B8860B]/20">
                    <Zap className="h-4 w-4 text-[#C8913A]" />
                  </div>
                </div>
                <div className="text-[#F5F3EF]">
                  <span className="text-2xl sm:text-3xl font-bold">10</span>
                  <span className="text-xs sm:text-sm font-medium opacity-70">万円〜</span>
                </div>
                <div className="text-[10px] sm:text-xs text-[#F5F3EF]/60 mt-1">LP制作から対応</div>
              </div>
            </div>
          </div>

          {/* 右カラム: PCではスペース（背景画像が見える） */}
          <div className="hidden lg:block" />
        </div>
      </div>
    </div>
  );
};

export default Hero;
